<template lang="">
    <div class="chartmode" ref="curvedRef">
  
    </div>
  </template>
  <script>
  import { Chart } from '@antv/g2';
  export default {
    props: {
        curveData: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            data: [
            { month: 'Jan', city: '待入库', temperature: 30 },
            { month: 'Jan', city: '出库中', temperature: 4 },
            { month: 'Jan', city: '已签收', temperature: 4 },
            { month: 'Feb', city: '待入库', temperature: 10 },
            { month: 'Feb', city: '出库中', temperature: 5},
            { month: 'Feb', city: '已签收', temperature: 5 },
            { month: 'Mar', city: '待入库', temperature: 22 },
            { month: 'Mar', city: '出库中', temperature: 3 },
            { month: 'Mar', city: '已签收', temperature: 6 },
            { month: 'Apr', city: '待入库', temperature: 35 },
            { month: 'Apr', city: '出库中', temperature: 4 },
            { month: 'Apr', city: '已签收', temperature: 9 },
            { month: 'May', city: '待入库', temperature: 32 },
            { month: 'May', city: '出库中', temperature: 4 },
            { month: 'May', city: '已签收', temperature: 12 },
            { month: 'Jun', city: '待入库', temperature: 22 },
            { month: 'Jun', city: '出库中', temperature: 4 },
            { month: 'Jun', city: '已签收', temperature: 15},
            { month: 'Jul', city: '待入库', temperature: 25 },
            { month: 'Jul', city: '出库中', temperature: 20 },
            { month: 'Jul', city: '已签收', temperature: 17 },
            { month: 'Aug', city: '待入库', temperature: 37 },
            { month: 'Aug', city: '出库中', temperature: 33 },
            { month: 'Aug', city: '已签收', temperature: 16 },
            { month: 'Sep', city: '待入库', temperature: 23 },
            { month: 'Sep', city: '出库中', temperature: 21 },
            { month: 'Sep', city: '已签收', temperature: 14 },
            { month: 'Oct', city: '待入库', temperature: 40 },
            { month: 'Oct', city: '出库中', temperature: 30 },
            { month: 'Oct', city: '已签收', temperature: 10 },
            { month: 'Nov', city: '待入库', temperature: 13 },
            { month: 'Nov', city: '出库中', temperature: 10 },
            { month: 'Nov', city: '已签收', temperature: 6 },
            { month: 'Dec', city: '待入库', temperature: 9 },
            { month: 'Dec', city: '出库中', temperature: 21 },
            { month: 'Dec', city: '已签收', temperature: 4 },
            ],
            chart: null,
        }
    },
    created() {
  
    },
    mounted() {
        this.chart = this.renderBarChart(this.$refs.curvedRef, this.curveData);
    },
    methods: {
        // 渲染条形图
        renderBarChart(container, data) {
            const chart = new Chart({
                container,
                autoFit: true,
                padding: [20,20,0,0]
            });
  
            // 声明可视化
            chart.interval() // 创建一个 Interval 标记
                .data(data) // 绑定数据
                .encode('x', 'month') // 编码 x 通道
                .encode('y', 'temperature') // 编码 y 通道
                .encode('color', 'city')
                .scale('x', { range: [0, 1]})
                .scale('y', {nice: true })
                .animate('update', { duration: 300 })
  
            //chart.line().encode('shape', 'smooth');
            //chart.point().encode('shape', 'point').tooltip(false);
            // 渲染可视化
           
            
            setTimeout(() => {
                chart.render();
            }, 0)
            return chart;
        }
    },
    watch: {
        curveData: function(newVal) {
            this.chart.changeData(newVal);
        }
    }
  }
  </script>
  <style lang="less">
  .chartmode {
    width: 100%;
    height: 100%;
  }
  </style>